/** Nur die Antwort der zuletzt gestarteten Anfrage darf den UI-Zustand ändern. */
export function istAktuelleAnfrage(anfrageId: number, aktuelleId: number): boolean {
    return anfrageId === aktuelleId;
}
